import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router";
import { Navbar } from '../components/Navbar.tsx';
import { FiCoffee } from "react-icons/fi";
import Coffee from '../components/Coffee';
import { FaRegFileZipper } from "react-icons/fa6";
import { MdOutlineCreateNewFolder } from "react-icons/md";
import { FiFileText } from "react-icons/fi";
import { RiDeleteBinLine } from "react-icons/ri";
import { Toaster, toast } from 'alert';
import { Footer } from "../components/Footer.tsx";
function Browse() {
    const [data, setData] = useState([
    ])
    
    const [isUploading, setUploading] = useState(false);
    const [res, setRes] = useState(data)
    const [search, setSearch] = useState("")
    const navigate = useNavigate()
    const [checker, setChecker] = useState(false);
    const [txt, setText] = useState("")
    const [file, setFile] = useState([]);
    const [event, setEvent] = useState()
    const [images, setImages] = useState([])
    const [resImages, setResimages]= useState([])
    const [showNewModal, setShowNewModal] = useState(false)
    const [newTitle, setNewTitle] = useState("")
    const [newTemplate, setNewTemplate] = useState("article")
    const [templates, setTemplates] = useState(["article", "report", "book", "proceedings"])
    const api = "https://backend.coffeelatek.com";

    useEffect(() => {
        axios.get(api + "/api/doc/templates", {
            headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` }
        }).then(res => {
            if (res.status == 200 && res.data.templates) {
                setTemplates(res.data.templates)
            }
        }).catch(() => {})
    }, [])

    useEffect(() => {
        if (localStorage.getItem("token") == undefined || localStorage.getItem("token") == null) {
            navigate("/login")
        } else {
            //setImages([])
            if (checker == false) {
               //console.log(images)
               load()
              
            }
            
    }},[checker])

const load = async()=>{
     setImages([])
     setResimages([])
              await  axios.get(api + "/api/doc/all", {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem("token")}`
                    }
                }).then(
                   async  response => {
                        //console.log(response)
                        if (response.status == 200 || response.status == 201) {

                            setRes(response.data.docs)
                            setData(response.data.docs)
                            
                            for (var i = 0; i < response.data.docs.length; i++) {
                                   //console.log(response.data.docs[i].id)
                            
                                 for (var i = 0; i < response.data.docs.length; i++) {
                      await axios.get(api + "/api/doc/image/" + response.data.docs[i].id,
                                    {
                                        responseType: "arraybuffer",
                                        headers: {
                                            "Authorization": `Bearer ${localStorage.getItem("token")}`,
                                            "Content-Type": "multipart/form-data",
                                        },
                                    }
                                ).then(res => {
                                    var file = new Blob([res.data])
                                    var fileUrl = URL.createObjectURL(file);
                                     
                                    setImages(images =>[...images, fileUrl])
                                    setResimages(images =>[...images, fileUrl])
                                }).catch(function () {
                                    console.log('image does not exist')
                                })
                              
            }
                            }
              
                            console.log(images)
                            setChecker(true)
                        } else {
                            localStorage.clear()
                            toast.error("An error has occured, please try to refresh the page")
                        }
                    }
                )
}

    const getImage=(id)=>{
      return   axios.get(api + "/api/doc/image/" + id,
                                    {
                                        responseType: "arraybuffer",
                                        headers: {
                                            "Authorization": `Bearer ${localStorage.getItem("token")}`,
                                            "Content-Type": "multipart/form-data",
                                        },
                                    }
                                ).then(res => {
                                    var file = new Blob([res.data])
                                    var fileUrl = URL.createObjectURL(file);
return fileUrl
                                }).catch(function () {
                                    console.log('image does not exist')
                                })
    }

    const generateText = (e) => {
        const id = localStorage.getItem("userId");
        setFile(e.target.files[0])
        setFile(e.target.files[0])

        const formData = new FormData();
        formData.append('key', file);
        console.log(id)
        console.log(formData)
        axios.post(
            api + "/api/document/text/" + id,
            formData,
            {
                responseType: "arraybuffer",
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        )
            .then((response) => {
                if (response.status == 200 || response.status == 201) {
                    var file = new Blob([response.data], { type: "text/plain" })

                    var fileUrl = URL.createObjectURL(file);
                    console.log(fileUrl)
                    setText(fileUrl)
                    if (fileUrl != null) {
                        window.open(fileUrl)
                    }
                }

            })
            .catch(function () {
                console.log("failed to upload file: try again")
            })
    }
    //handle delete
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this document? This action cannot be undone.")) {
            axios.delete(api + "/api/doc/project/delete/" + id, {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("token")}`
                }
            }).then(
                res => {
                    if (res.status == 200 || res.status == 201) {
                        setChecker(false)
                    } else if (res.status == 400) {
                        localStorage.clear()
                    }
                    else {
                        toast.error("internal server error")
                    }
                }
            )
        }
    }

    const handleEdit = (id) => {
        navigate("/document/" + id)
    }


    const handleChange = (e) => {

        if (e.target.value == "") {
            setResimages(images)
            setRes(data)
        } else {
            setRes([])
            setResimages([])
            const s = data.flatMap((item, i) => item.title.includes(e.target.value)? i: [])
            s.map(item => setRes(items=>[...items, data[item]]))
            s.map(item => setResimages(ims=>[...ims, images[item]]))
          
        }

    }
    const handleNew = () => {
        setNewTitle("")
        setNewTemplate(templates[0] || "article")
        setShowNewModal(true)
    }

    const handleCreateProject = () => {
        var title = newTitle;
        if (title != "" && title != null) {
            setShowNewModal(false)
            axios.post(api + '/api/doc/create', {
                title: title,
                template: newTemplate
            }, {
                headers: {
                    "Authorization": `Bearer ${localStorage.getItem("token")}`
                }
            }).then(async res => { 
                if (res.status == 200 || res.status == 201) { 
                    let newDoc = res.data.doc || res.data.document || res.data;
                    
                    if (!newDoc || !newDoc.id) {
                        try {
                            const allRes = await axios.get(api + "/api/doc/all", {
                                headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
                            });
                            if (allRes.status == 200 || allRes.status == 201) {
                                const docs = allRes.data.docs;
                                const currentIds = new Set(data.map(d => d.id));
                                newDoc = docs.find(d => !currentIds.has(d.id));
                            }
                        } catch (e) {
                            console.error(e);
                        }
                    }

                    if (newDoc && newDoc.id) {
                        setData(prev => [...prev, newDoc]);
                        setRes(prev => [...prev, newDoc]);
                        
                        try {
                            const imgRes = await axios.get(api + "/api/doc/image/" + newDoc.id, {
                                responseType: "arraybuffer",
                                headers: {
                                    "Authorization": `Bearer ${localStorage.getItem("token")}`,
                                    "Content-Type": "multipart/form-data",
                                }
                            });
                            var file = new Blob([imgRes.data]);
                            var fileUrl = URL.createObjectURL(file);
                            setImages(prev => [...prev, fileUrl]);
                            setResimages(prev => [...prev, fileUrl]);
                        } catch (e) {
                            setImages(prev => [...prev, null]);
                            setResimages(prev => [...prev, null]);
                        }
                    } else {
                        setChecker(false);
                    }
                } else { 
                    toast.error("an error has occured") 
                } 
            }).catch(err => {
                toast.error("an error has occured")
            })
        }
    }




    const handleUpload = async (e) => {
        const formData = new FormData();
        formData.append('file', e.target.files[0]);

        setUploading(true)
        await axios.post(
            api + "/api/doc/upload",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${localStorage.getItem("token")}`

                },
            }
        )
            .then((response) => {
                if (response.status == 200 || response.status == 201) {
                    console.log(response.data["doc"])
                    toast.success("file uploaded")
                    setChecker(false)
                }

            })
            .catch(function () {
                toast.error("check your file")
            })
        setUploading(false)
        e.target.value=""
    }
    const Docx = async (e) => {
        const id = localStorage.getItem("userId");
        console.log(e.target.files)

        const formData = new FormData();
        formData.append('key', e.target.files[0]);

        setUploading(true)
        await axios
            .post(
                api + "/api/document/docx/" + localStorage.getItem("userId"),
                formData,
                {
                    responseType: "arraybuffer",
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            )
            .then((response) => {
                if (response.status == 200 || response.status == 201) {
                    console.log(response.data["document"])
                    toast.success("file uploaded")
                    axios.get(api + "/api/doc/all", {
                        headers: {
                            'Authorization': `Token ${localStorage.getItem("token")}`
                        }
                    }).then(
                        response => {
                            if (response.status == 200 || response.status == 201) {
                                console.log(response.data.docs)
                                setRes(response.data.docs)
                                setData(response.data.docs)
                                setChecker(true)
                            } else {
                                localStorage.clear()
                                toast.error("Please make sure that the file is valid")
                            }
                        }
                    )
                }

            })
            .catch(function () {
                toast.error("check your file")
            })
        setUploading(false)
    }
    return (<>

<Navbar />
       <div className="container">
 <Toaster position='top-center'/>
       </div>
          

 <div className=" container  ">
                            {isUploading == true ? <div className="container co first-color">Please wait, we are uploading your ZIP file ...</div> : <></>}


       
        
            <div >
                <center>
                    <h1>Welcome to CoffeeLaTek <FiCoffee /> </h1>
                    <h6>You can start writing in LaTex and generating PDF documents in seconds</h6>
                </center>
            </div>
         

        </div>

        <div className="container border-col">
            <h2>LaTex Documents</h2>
            <p>If you are trying to upload a zip file, please rename the entrypoint to <strong>main.tex</strong>. However, you should compile the entrypoint by yourself whenever the document is uploaded.</p>
            <center>
                <div className="row">
                    <div className="column ">
                        <input className="float-right" placeholder="Search for document..." onChange={handleChange} />
                    </div>
                    <div className="column column-25">

                        <div className="box">

                            <div className="one">
                                <label for="files" class="button button-black file-label float-right">ZIP <FaRegFileZipper /></label>
                            </div>
                            <div className="one">
                                <input className="hide" id="files" type="file" onChange={handleUpload} />
                            </div>

                            <div className="one">
                                <button className="button  button-dark " onClick={handleNew}>New <MdOutlineCreateNewFolder /></button></div>

                        </div>
                    </div>




                </div>

                <br />
                <div className="cards">
                    {res.length == 0 ? <h4>No document created ...</h4> : res.map((item, i) => (

                        <article class="card">

                            <img src={resImages[i]} />
                    
                            <footer>
                                   <p> <strong>{item.title}</strong> <br/> {item.id}</p>
                        
                                <div className="box" style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
                                    <div className="one" onClick={() => handleEdit(item.id)} style={{ cursor: 'pointer', textAlign: 'center' }}>
                                        <FiFileText size={20}/><br/> Edit
                                    </div>
                                    <div className="one" onClick={() => handleDelete(item.id)} style={{ cursor: 'pointer', textAlign: 'center' }}>
                                        <RiDeleteBinLine size={20}/><br/> Delete
                                    </div>
                                </div>
                            </footer>
                        </article>

                    ))}
                </div>
            </center>   <br />   </div><br/>
                 <div className="">
     <Footer />
     </div>

     {showNewModal ? (
        <div className="modal-overlay" onClick={() => setShowNewModal(false)}>
            <div className="modal-box" onClick={(e) => e.stopPropagation()}>
                <h4>New document</h4>
                <label for="new-doc-title">Title</label>
                <input
                    id="new-doc-title"
                    placeholder="Project title"
                    value={newTitle}
                    onChange={(e) => setNewTitle(e.target.value)}
                    autoFocus
                />
                <label for="new-doc-template">Template</label>
                <select
                    id="new-doc-template"
                    value={newTemplate}
                    onChange={(e) => setNewTemplate(e.target.value)}
                >
                    {templates.map((t) => (
                        <option key={t} value={t}>{t.charAt(0).toUpperCase() + t.slice(1)}</option>
                    ))}
                </select>
                <div className="box" style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1rem' }}>
                    <button className="button button-outline" onClick={() => setShowNewModal(false)}>Cancel</button>
                    <button className="button button-dark" onClick={handleCreateProject}>Create</button>
                </div>
            </div>
        </div>
     ) : <></>}
     </>
    )
}
export default Browse;